import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-customer-share-indicador-badge',
    templateUrl: './customer-share-indicador-badge.component.html',
    styleUrls: ['./customer-share-indicador-badge.component.less']
})
export class CustomerShareIndicadorBadgeComponent {
    @Input() indicador: number;

    @Input() perc: number = null;
    @Input() percMinIntegerDigits = 1;
    @Input() percMinFractionDigits = 0;
    @Input() percMaxFractionDigits = 0;

    @Input() fontSize = '75%';
    @Input() padding = '0.4rem';
    @Input() width = 'auto';
}
